import { useEffect } from "react";
import type { CarConfigDispatchType } from "../redux/store";
import { useCarConfigSelector } from "../redux/store";
import { startEtaLoad } from "../redux/slices/CarConfigEtaSlice";
import { useDispatch } from "../../../../shared-logic/redux/store";

const useAphEtaInit = (): void => {
    const dispatch = useDispatch<CarConfigDispatchType>();
    const carConfigSettings = useCarConfigSelector((state) => state.carConfigSettings);
    const etaLoaded = useCarConfigSelector((state) => state.eta.loaded);

    useEffect(() => {
        // Eta gets invalidated on v2 when configuration changes,
        // this means we can use the loaded prop check here even when summary has already been opened once
        if (carConfigSettings.showETA && !etaLoaded) dispatch(startEtaLoad());

        // Only needs to run once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useAphEtaInit;
